import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import * as pages from 'pages'

export default () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={pages.Home} />
        <Route path="/Locations" component={pages.Locations} />
        <Route exact path="/vancouver" component={pages.Home} />
        <Route exact path="/coquitlam" component={pages.Home} />
        <Route component={pages.Page404} />
      </Switch>
    </Router>
  )
}
